import {translationBaseKey} from '../../../../../decorators/translation-base-key.decorator';
import {clonePropertyMetadata} from '@pristine-ts/metadata';
import {IncomeTaxPersonalChildQuebecOptions} from '../quebec/income-tax-personal-child-quebec.options';

@translationBaseKey('income-tax-personal-child-quebec-in-income-tax-personal-options')
export class IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions implements Omit<IncomeTaxPersonalChildQuebecOptions,
  'firstName' |
  'lastName' |
  'birthdate' |
  'camps' |
  'id' |
  'isDisabled' |
  'name' |
  'isStudying' |
  'netIncome'> {
  @clonePropertyMetadata<IncomeTaxPersonalChildQuebecOptions>(IncomeTaxPersonalChildQuebecOptions, 'careExpensesOthers')
  careExpensesOthers: number;
}